/* tslint:disable */
/* eslint-disable */
/**
 * Vividi Dashboard API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    DockerImageResponse,
    DockerImageResponseFromJSON,
    DockerImageResponseFromJSONTyped,
    DockerImageResponseToJSON,
} from './DockerImageResponse';

/**
 * 
 * @export
 * @interface DockerImageListResponse
 */
export interface DockerImageListResponse {
    /**
     * 
     * @type {Array<DockerImageResponse>}
     * @memberof DockerImageListResponse
     */
    images: Array<DockerImageResponse>;
}

export function DockerImageListResponseFromJSON(json: any): DockerImageListResponse {
    return DockerImageListResponseFromJSONTyped(json, false);
}

export function DockerImageListResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): DockerImageListResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'images': ((json['images'] as Array<any>).map(DockerImageResponseFromJSON)),
    };
}

export function DockerImageListResponseToJSON(value?: DockerImageListResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'images': ((value.images as Array<any>).map(DockerImageResponseToJSON)),
    };
}

